import {ErrorBoundary} from "react-error-boundary";
import {ChatList} from "../chat-list";
import {MessageCustomerList} from "../message-customer-list";
import {StyledMessageListBox} from "./message-list.style";
import {Alert, Button} from "antd";

const MessageList = () => {
  return (
    <StyledMessageListBox>
      <ErrorBoundary
        FallbackComponent={({error, resetErrorBoundary}) => (
          <div>
            <Alert
              message="Sorry, something went wrong."
              showIcon
              description={error.message}
              type="error"
              action={
                <Button
                  onClick={() => {
                    resetErrorBoundary();
                  }}
                  size="small"
                  danger
                >
                  Reset
                </Button>
              }
            />
          </div>
        )}
      >
        <MessageCustomerList />
      </ErrorBoundary>
      <ErrorBoundary
        FallbackComponent={({error, resetErrorBoundary}) => (
          <div>
            <Alert
              message="Sorry, something went wrong."
              showIcon
              description={error.message}
              type="error"
              action={
                <Button
                  onClick={() => {
                    resetErrorBoundary();
                  }}
                  size="small"
                  danger
                >
                  Reset
                </Button>
              }
            />
          </div>
        )}
      >
        <ChatList />
      </ErrorBoundary>
    </StyledMessageListBox>
  );
};

export {MessageList};
